import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { grey } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Link } from 'shared/mui/Link/Link';
import { Typography } from 'shared/mui/Typography';

import { PlaceholderWrapperStyled } from './TableFileViewerUploader.styled';

type FileUploaderPlaceholderProps = {
  onClick: () => void;
};

export const TableFileViewerUploaderPlaceholder: React.FC<FileUploaderPlaceholderProps> = ({
  onClick,
}) => {
  const translate = useTypedTranslate();

  return (
    <PlaceholderWrapperStyled onClick={onClick}>
      <UploadFileOutlinedIcon sx={{ fontSize: '28px', color: grey[600], marginRight: '4px' }} />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Link sx={{ marginTop: '1px' }}>{translate('app.merchantCommissions.clickToUpload')}</Link>
        <Typography sx={{ lineHeight: '28px', marginLeft: '4px' }} variant="subtitle1">
          {translate('app.merchantCommissions.orDragFile')}
        </Typography>
      </Box>
    </PlaceholderWrapperStyled>
  );
};
